/**
 * Get a random integer between min (included) and max
 *
 * @param {number} min the lower bound
 * @param {number} max the upper bound
 * @returns an integer in the range [min, max)
 */
export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);

  return Math.floor(Math.random() * (max - min) + min);
};
